
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spa/treatments",
      function () {
        return require("private-next-pages/spa/treatments/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spa/treatments"])
      });
    }
  